
<!--users list modal-->
<div class="modal fade bd-example-modal-lg" bsModal #listModal="bs-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title float-left">
          <i class="material-icons m-r-10">supervisor_account</i>
          {{'Modules.Shared.Users.Selector.Title' | translate}}
        </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="listModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <!--filters-->
        <div class="pc-form-filters pc-form-filters--modal">
          <form [formGroup]="_searchForm" (ngSubmit)="search()">
            <div class="row">
              <div class="col-lg-2">
                <div class="form-group">
                  <label>Nome:</label>
                  <mat-form-field>
                    <input type="text" matInput formControlName="name" />
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-2">
                <div class="form-group">
                  <label>E-mail:</label>
                  <mat-form-field>
                    <input type="text" matInput formControlName="email" />
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-2">
                <button type="submit" mat-ripple class="btn btn-blue">
                  <i class="material-icons">search</i>
                  {{'Commons.Actions.Search' | translate}}
                </button>
              </div>
            </div>
          </form>
        </div>

        <!--results-->
        <div class="table-responsive">
          @if (_showTable) {
            <table datatable [dtOptions]="_dtOptions" class="table row-border hover"></table>
          }
        </div>

      </div>
    </div>
  </div>
</div>